// Import wallet-lib constants
import { constants as walletLibConstants } from '@hathor/wallet-lib';

// Network configuration
export const NETWORKS = {
  MAINNET: 'mainnet',
  TESTNET: 'testnet'
} as const;

// WafpWYepbV13FVM9Qp9brmBTXgjrn3dnfx 
// Hathor API endpoints
export const HATHOR_API_URLS = {
  MAINNET: 'https://node1.mainnet.hathor.network/v1a',
  TESTNET: 'https://node1.testnet.hathor.network/v1a'
} as const;

// Hathor explorer URLs
export const HATHOR_EXPLORER_URLS = {
  MAINNET: 'https://explorer.hathor.network',
  TESTNET: 'https://explorer.testnet.hathor.network'
} as const;

// Wallet service URLs
export const WALLET_SERVICE_URLS = {
  MAINNET: 'https://wallet-service.hathor.network/',
  TESTNET: 'https://wallet-service.testnet.hathor.network/'
} as const;

// Wallet service WebSocket URLs
export const WALLET_SERVICE_WS_URLS = {
  MAINNET: 'wss://ws.wallet-service.hathor.network/',
  TESTNET: 'wss://ws.wallet-service.testnet.hathor.network/'
} as const;

// Token IDs - Re-export from wallet-lib for convenience
export const TOKEN_IDS = {
  HTR: walletLibConstants.NATIVE_TOKEN_UID
} as const;

// HTR Token Information
export const HTR_TOKEN_INFO = {
  uid: TOKEN_IDS.HTR,
  name: 'Hathor',
  symbol: 'HTR',
  isNFT: false,
} as const;

// Decimal places for HTR (used for conversion between HTR and cents)
export const HTR_DECIMAL_PLACES = walletLibConstants.DECIMAL_PLACES;
export const HTR_DECIMAL_MULTIPLIER = 10 ** HTR_DECIMAL_PLACES; // 100
export const HTR_DECIMAL_MULTIPLIER_BIGINT = BigInt(10 ** HTR_DECIMAL_PLACES); // 100n

// Default configuration
export const DEFAULT_NETWORK = NETWORKS.MAINNET;
export const DEFAULT_ADDRESS_INDEX = 0;
export const DEFAULT_ADDRESS_TYPE = 'index' as const;

// localStorage key for the active network. Owned by the NetworkProvider, which
// is the single source of truth for the active network and the only place that
// reads/writes this key.
export const NETWORK_STORAGE_KEY = 'hathor_wallet_network';

// UI Constants
export const QR_CODE_SIZE = 200;
export const TRANSACTION_HISTORY_LIMIT = 50;
export const CHECK_CONNECTION_TIMEOUT = 10000;

// Snap Version Requirements
export const MIN_SNAP_VERSION = process.env.MIN_SNAP_VERSION || '0.0.0';

// Stage configuration (production/staging)
export const STAGE = process.env.STAGE || 'production';

// Feature toggle configuration
// Set to 'true' to skip feature toggle checks (useful for tests/CI)
export const SKIP_FEATURE_TOGGLE = process.env.SKIP_FEATURE_TOGGLE === 'true';

// MetaMask Snaps URLs
export const METAMASK_SNAP_URL = 'https://snaps.metamask.io/snap/npm/hathor/snap';

// Unleash configuration (same as mobile wallet)
export const UNLEASH_URL = 'https://unleash-proxy.b7e6a7f52ee9fefaf0c53e300cfcb014.hathor.network/proxy';
export const UNLEASH_CLIENT_KEY = 'wKNhpEXKa39aTRgIjcNsO4Im618bRGTq';
export const UNLEASH_POLLING_INTERVAL = 15 * 1000; // 15s

// Feature toggle names
export const WEB_WALLET_MAINTENANCE_TOGGLE = 'web-wallet.maintenance';
// Web-wallet-specific rollout flag for fee-based tokens (separate from
// hathor-wallet-mobile's 'fee-based-tokens.rollout' so each client can be
// rolled out independently).
export const FEE_BASED_TOKENS_TOGGLE = 'fee-based-tokens-webwallet.rollout';

// Feature toggle defaults
// Note: Unleash Proxy only returns enabled toggles. If a toggle is disabled or
// doesn't exist, it won't be in the response.
export const FEATURE_TOGGLE_DEFAULTS: Record<string, boolean> = {
  [WEB_WALLET_MAINTENANCE_TOGGLE]: false, // Default: not under maintenance
  [FEE_BASED_TOKENS_TOGGLE]: false, // Default: fee-based tokens feature disabled
};
